import axios from 'axios';
import {
    ATTENDANCE_GET_ONE,
    ATTENDANCE_GET_MULTIPLE,
    ATTENDANCE_GET_DROPDOWNS,
    ATTENDANCE_REGISTER_SUCCESS,
    ATTENDANCE_REGISTER_FAIL,
    ATTENDANCE_LOADING,
    ATTENDANCE_LOADING_ERROR,
    ATTENDANCE_UPDATE_SUCCESS,
    ATTENDANCE_UPDATE_FAIL,
    ATTENDANCE_DELETE_SUCCESS,
    ATTENDANCE_DELETE_FAIL
} from "./../types/attendance";
import { MAIN_TOKEN, SERVER_PATH, axiosConfig1, axiosConfig } from './common';

let TABLE_NAME = 'attendances';
const path = SERVER_PATH;

//GET ALL ATTENDANCE 
export const getAttendances = params => (dispatch, getState) => {
    //SET PAGE LOADING
    params.token = MAIN_TOKEN;
    params.table = TABLE_NAME;

    dispatch({type : ATTENDANCE_LOADING});
        axios.get(path, {params}, axiosConfig)
            .then(res => {                                                                                                                                                                                                                                        
                dispatch({
                    type: ATTENDANCE_GET_MULTIPLE,
                    payload: res.data
                })
            })
            .catch(err => {
                dispatch({
                    type : ATTENDANCE_LOADING_ERROR,
                    payload:err
                })
            })
};
//GET ALL ATTENDANCE 
export const getAttendancedropdowns = params => (dispatch, getState) => {
    //SET PAGE LOADING
    params.token = MAIN_TOKEN;
    params.table = TABLE_NAME;

    dispatch({type : ATTENDANCE_LOADING});
        axios.get(path, {params}, axiosConfig)
            .then(res => {                                                                                                                                                                                                                                        
                dispatch({
                    type: ATTENDANCE_GET_DROPDOWNS,
                    payload: res.data
                })
            })
            .catch(err => {
                dispatch({
                    type : ATTENDANCE_LOADING_ERROR,
                    payload:err
                })
            })
};
//GET SINGLE ATTENDANCE 
export const getAttendance = id => (dispatch, getState) => {
    //SET PAGE LOADING
    dispatch(
        {
        type : ATTENDANCE_GET_ONE,
        payload: id
    });  
};
//ATTENDANCE DELETE
export const deleteAttendance = params => (dispatch, getState) =>{
    axios.POST(path, {params}, axiosConfig)
        .then(res => {
            dispatch({
                type: ATTENDANCE_DELETE_SUCCESS,
                payload: params.id
            })
        })
        .catch(err => {
            dispatch({
                type : ATTENDANCE_DELETE_FAIL,
                payload : err
            })
        })
        
}
//ATTENDANCE REGISTER
export const registerAttendance = data => dispatch => {
    axios.post(path, data, axiosConfig1)
        .then(res => {
            dispatch({
                type: ATTENDANCE_REGISTER_SUCCESS,
                payload: res.data.data
            })
        })
        .catch(err => {
            dispatch({
                type : ATTENDANCE_REGISTER_FAIL,
                payload: err
            })
        })
};
 //ATTENDANCE UPDATE
export const updateAttendance = (data) => (dispatch, getState) => {
    //body
    axios.post(path, data, axiosConfig1)
        .then(res => {
            dispatch({
                type: ATTENDANCE_UPDATE_SUCCESS,
                payload: res.data.data
            })
        })
        .catch(err => {
            dispatch({
                type : ATTENDANCE_UPDATE_FAIL,
                payload: err
            })
        })
};
